'use client';
import React, { useState } from 'react';
import { SessionContext } from '@benzinga/session-context';
import { useActiveWorkspaceSubscriber } from '@benzinga/pro-tools';
import { Security, Quote, QuoteFeedEvent } from '@benzinga/quotes-v3-manager';
import { QuotesV3HoldingsManager } from '@benzinga/quotes-v3-holdings-manager';

export const useQuoteMultiplexSubscription = (symbols: Security[], fields: Set<keyof Quote>): Quote[] | undefined => {
  const [quotes, setQuotes] = useState<Quote[] | undefined>(undefined);
  useQuoteMultiplexSubscriptionCallback(symbols, fields, setQuotes);
  return quotes;
};

export const useQuoteMultiplexSubscriptionCallback = (
  symbols: Security[],
  fields: Set<keyof Quote>,
  callback: (quote: Quote[]) => void,
) => {
  const session = React.useContext(SessionContext);
  const quotesManager = session.getManager(QuotesV3HoldingsManager);

  const feed = React.useMemo(() => quotesManager.createQuotesFeed(symbols, true), [quotesManager, symbols]);

  useActiveWorkspaceSubscriber(
    feed as any,
    (event: QuoteFeedEvent) => {
      switch (event.type) {
        case 'quote':
          callback(feed.getCachedValue());
          break;
      }
    },
    fields,
  );
};
